import {useStyles} from '../../../hooks/styles';

export function useYaMapStyles() {
  return useStyles(({theme}) => ({
    mapView: {
      overflow: 'hidden',
      height: '100%',
    },
    info: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1,
      backgroundColor: theme.color.backgroundMenuColor,
      paddingBottom: 12,
      paddingHorizontal: 16,
    },
    infoRow: {
      marginBottom: 8,
    },
    rowWithIcon: {
      flexDirection: 'row',
      paddingRight: 32,
    },
    icon: {
      marginRight: 12,
      color: theme.color.primaryColor,
      justifyContent: 'center',
      height: 16,
    },
    groupItem: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: 12,
      paddingVertical: 5,
    },
  }));
}
